import clsx from 'clsx'
import useTranslation from 'next-translate/useTranslation'

function NewnessBadge({ className }: NewnessBadgeProps) {
  const { t } = useTranslation('global')

  return (
    <div
      className={clsx(
        'flex items-center justify-center w-6 h-6 bg-green-100 rounded-full p-6',
        className
      )}
    >
      <p className="text-xs font-semibold text-white md:text-sm">
        {t('badge_new')}
      </p>
    </div>
  )
}

interface NewnessBadgeProps {
  className?: string
}

export default NewnessBadge
